import AtbAxios from '@core/api/default-client/axiosInstance'
import { AxiosInstance, AxiosError } from 'axios'

AtbAxios.interceptors.request.use(
    (config) => {
        config.headers.set('X-Requested-With', 'Stance')
        config.headers.set(
            'x-at-bay-csrf',
            document.cookie
                .split(';')
                .find((cookie) => cookie.includes('at-bay-csrf-token'))
                ?.split('=')[1] ?? 'No CSRF'
        )

        return config
    },
    undefined,
    { synchronous: true }
)

export { AtbAxios as BaseClient }
export type { AxiosInstance, AxiosError }
